module.exports = __webpack_public_path__ + "img/philippines.7a520dce.svg";